@if (name) {
  <span class="object-name-component {{stylingClass}}">
    @if (!translate) {
      <span
        [innerHTML]="name"
      ></span>
    }
    @else {
      <span>
        {{ name | translate }}
      </span>
    }
</span>
}
